<template>
  <div class="modal">
    <div class="modal__container surface">
      <div class="modal__head">
        <span class="modal__title">Detalle de Tarifa</span>
        <div class="modal__close">
          <span @click.prevent="close()"><i class="fas fa-times"/></span>
        </div>
      </div>
      <div class="modal__body">
        <calendarOW></calendarOW>
      </div>
      <div class="modal__footer">
        <button class="btn">
          <i class="fas fa-times mr-2"></i>
          {{ $t('calendar_close') }}
        </button>
        <button class="btn btn-primary ml-2" @click.prevent="close()">
          <i class="fas fa-check mr-2"></i>
          {{ $t('calendar_continue') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import calendarOW from './calendarOW.vue'
export default {
  name: 'modalOW',
  components: {
    calendarOW
  },
  methods: {
    close () {
      this.$emit('closeModal')
    }
  }
}
</script>

<style lang="sass" scoped>
.modal
  z-index: 99999
  width: 100vw
  height: 100vh
  background: var(--color-overlay-70)
  position: fixed
  top: 0
  left: 0
  display: block
  padding: 1rem
  &__container
    max-width: 1024px
    width: 100%
    flex-direction: column
    margin: 0 auto
  &__head
    display: flex
    justify-content: space-between
    border-bottom: 1px solid var(--color-overlay-20)
    align-items: center
  &__body
    display: flex
    height: auto
    overflow-y: auto
  &__close
    width: 3rem
    height: 3rem
    display: flex
    align-items: center
    opacity: .4
    justify-content: center
    cursor: pointer
    &:hover
      opacity: 1
      background-color: var(--color-overlay-05)
  &__title
    display: flex
    align-items: center
    padding: 0 1rem
  &__footer
    padding: .5rem 1rem
    justify-content: flex-end
    display: flex
    border-top: 1px solid var(--color-overlay-20)
@media (min-width: 768px)
  .modal
    &__close
      width: 3rem
      height: 3rem
</style>
